import { WaitlistNotificationParams } from 'shared/schemas/resend'
import {
  createVariantsResponseSchema,
  DeleteProductParams,
  SetQuantitiesParams,
  UpdateVariantsParams,
  ShopifyCreateProductParams,
  ShopifyCreateVariantsParams,
} from '../../shared/schemas/shopify'
import { z } from 'zod'
import { shopifyOrderSchema, shopifyProductSchema } from '~/features/shopify/schemas'

const get_products = async () => {
  const response = await fetch('/api/shopify/get_products', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return await response.json()
}

const create_product = async (params: ShopifyCreateProductParams) => {
  const response = await fetch('/api/shopify/create_product', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
  return await response.json()
}

const create_variants = async (params: ShopifyCreateVariantsParams) => {
  const response = await fetch('/api/shopify/create_variants', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
  return await response.json()
}

const set_quantities = async (params: SetQuantitiesParams) => {
  const response = await fetch('/api/shopify/set_quantities', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })

  return await response.json()
}

const update_variants = async (params: UpdateVariantsParams) => {
  const response = await fetch('/api/shopify/update_variants', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
  return await response.json()
}

const get_order = async (orderId: string) => {
  const response = await fetch(`/api/shopify/get_order?orderId=${encodeURIComponent(orderId)}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
  return await response.json()
}

const delete_product = async (params: DeleteProductParams) => {
  const response = await fetch('/api/shopify/delete_product', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
  return await response.json()
}

const send_waitlist_notification = async (params: WaitlistNotificationParams) => {
  const response = await fetch('/api/emails/send_waitlist_notification', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
  return await response.json()
}

export const internal_backend = {
  get_products: {
    request: get_products,
    responseSchema: z.object({
      products: z.object({ edges: z.array(z.object({ node: shopifyProductSchema })) }),
    }),
  },
  create_product: {
    request: create_product,
    responseSchema: z.object({
      product: z.object({
        id: z.string(),
        title: z.string(),
        metafields: z.object({
          edges: z.array(
            z.object({
              node: z.object({
                id: z.string(),
                namespace: z.string(),
                key: z.string(),
                value: z.string(),
                type: z.string(),
              }),
            })
          ),
        }),
      }),
    }),
  },
  create_variants: {
    request: create_variants,
    responseSchema: createVariantsResponseSchema,
  },
  set_quantities: { request: set_quantities, responseSchema: null },
  update_variants: { request: update_variants, responseSchema: null },
  delete_product: {
    request: delete_product,
    responseSchema: z.object({ deletedProductId: z.string() }),
  },
  get_order: {
    request: get_order,
    responseSchema: z.object({ order: shopifyOrderSchema }),
  },
  send_waitlist_notification: {
    request: send_waitlist_notification,
    responseSchema: null,
  },
} as const
